module.exports = __webpack_public_path__ + "img/icon8_H.497d8bde.png";